<div>
    @if ((displayQuoting$ | async)) {
      @if (!(loading$ | async)) {
        <app-shipment-quoting [shipmentId]="shipmentId$ | async"></app-shipment-quoting>
      }
      @if (loading$ | async) {
        <div class="flex flex-col gap-4 m-16 justify-center items-center">
          <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
        </div>
      }
    } @else {
      @if (!(loading$ | async)) {
        <app-shipment-editor></app-shipment-editor>
      }
      @if (loading$ | async) {
        <div class="flex flex-col gap-4 m-16 justify-center items-center">
          <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
        </div>
      }
    }
</div>
